<template>
  <ul v-if="items.length" class="navigation-sub-items">
    <li v-for="item in items" :key="item.title">
      <NavigationSubItem v-bind="item" />
    </li>
  </ul>
</template>

<script>
import NavigationSubItem from './NavigationSubItem';
export default {
  name: 'NavigationSubItems',
  components: { NavigationSubItem },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
.navigation-sub-items {
  list-style: none;
}
</style>
